if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.initLightbox();
      }

      initLightbox() {
        this.prevBtn = this.querySelector('.binge-modal-nav--prev');
        this.nextBtn = this.querySelector('.binge-modal-nav--next');
        this.counterCurrent = this.querySelector('.binge-modal-counter__current');
        this.counterTotal = this.querySelector('.binge-modal-counter__total');
        this.dialog = this.querySelector('.product-media-modal__dialog');
        this.content = this.querySelector('.product-media-modal__content');

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showPrevMedia();
          });
          this.prevBtn.addEventListener('pointerup', (e) => e.stopPropagation());
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showNextMedia();
          });
          this.nextBtn.addEventListener('pointerup', (e) => e.stopPropagation());
        }

        if (this.content) {
          // Prevent clicking the image content from closing the lightbox
          this.content.addEventListener('click', (e) => e.stopPropagation());
          this.content.addEventListener('pointerup', (e) => e.stopPropagation());

          // Touch swipe support for mobile
          let touchStartX = 0;
          let touchEndX = 0;
          this.content.addEventListener(
            'touchstart',
            (e) => {
              if (e.changedTouches && e.changedTouches[0]) {
                touchStartX = e.changedTouches[0].screenX;
              }
            },
            { passive: true }
          );
          this.content.addEventListener(
            'touchend',
            (e) => {
              if (e.changedTouches && e.changedTouches[0]) {
                touchEndX = e.changedTouches[0].screenX;
                const diff = touchEndX - touchStartX;
                if (diff > 50) {
                  this.showPrevMedia();
                } else if (diff < -50) {
                  this.showNextMedia();
                }
              }
            },
            { passive: true }
          );
        }

        // Keyboard arrow navigation
        window.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.showPrevMedia();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.showNextMedia();
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        const targetMediaId =
          opener?.getAttribute('data-media-id') ||
          opener?.querySelector('[data-media-id]')?.getAttribute('data-media-id');
        this.setActiveMediaById(targetMediaId);
      }

      getVisibleMedia() {
        // Collect visible modal items that are not hidden by color variant filtering
        const items = Array.from(this.querySelectorAll('.product-media-modal__item'));
        const activeItems = items.filter((el) => !el.classList.contains('is-color-hidden'));
        return activeItems.length > 0 ? activeItems : items;
      }

      setActiveMediaById(mediaId) {
        const visibleItems = this.getVisibleMedia();
        if (visibleItems.length === 0) return;

        let targetIndex = visibleItems.findIndex((el) => el.getAttribute('data-media-id') === mediaId);
        if (targetIndex === -1) targetIndex = 0;

        this.setActiveIndex(targetIndex);
      }

      setActiveIndex(index) {
        const allItems = Array.from(this.querySelectorAll('.product-media-modal__item'));
        const visibleItems = this.getVisibleMedia();
        if (visibleItems.length === 0) return;

        const total = visibleItems.length;
        const normalizedIndex = ((index % total) + total) % total;
        const activeEl = visibleItems[normalizedIndex];

        allItems.forEach((el) => {
          if (el === activeEl) {
            el.classList.add('active');
            el.style.display = 'flex';

            const activeMediaTemplate = el.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            if (
              el.nodeName === 'DEFERRED-MEDIA' &&
              activeMediaContent &&
              activeMediaContent.querySelector('.js-youtube')
            ) {
              el.loadContent();
            }
          } else {
            el.classList.remove('active');
            el.style.display = 'none';
          }
        });

        if (this.counterCurrent) this.counterCurrent.textContent = normalizedIndex + 1;
        if (this.counterTotal) this.counterTotal.textContent = total;

        if (this.prevBtn && this.nextBtn) {
          const showNav = total > 1;
          this.prevBtn.style.display = showNav ? 'flex' : 'none';
          this.nextBtn.style.display = showNav ? 'flex' : 'none';
        }
        const counterEl = this.querySelector('.binge-modal-counter');
        if (counterEl) {
          counterEl.style.display = total > 1 ? 'inline-flex' : 'none';
        }
      }

      showNextMedia() {
        const visibleItems = this.getVisibleMedia();
        const currentIndex = visibleItems.findIndex((el) => el.classList.contains('active'));
        this.setActiveIndex(currentIndex + 1);
      }

      showPrevMedia() {
        const visibleItems = this.getVisibleMedia();
        const currentIndex = visibleItems.findIndex((el) => el.classList.contains('active'));
        this.setActiveIndex(currentIndex - 1);
      }
    }
  );
}
